import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src", "onErrorOnce"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "user_name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "more_user_count" }
const _hoisted_6 = { class: "more_user_text" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import Avatar1 from '@/assets/img/meeting-room/avatar-1.png';
import Avatar2 from '@/assets/img/meeting-room/avatar-2.png';
import Avatar3 from '@/assets/img/meeting-room/avatar-3.png';
import Avatar4 from '@/assets/img/meeting-room/avatar-4.png';
import Avatar5 from '@/assets/img/meeting-room/avatar-5.png';
import UserMicMutedIcon from '@/assets/img/meeting-room/user-mic-muted.png';
import UserMicOnIcon from '@/assets/img/meeting-room/user-mic-on.png';
import {
  getDefaultAvatar,
  getUserIdentity,
  getRoleText,
  getUserAvatar,
  getUserKey,
  getUserName,
  getUserPledgeLogo,
  isMuted,
  isRtcUidMatched,
  MeetingUser,
} from './meetingRoomUsers';


export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingRoomUserGrid',
  props: {
    users: {},
    totalUserCount: {},
    pageSize: {},
    hasSharedScreen: { type: Boolean },
    screenFullscreen: { type: Boolean },
    speakingRtcUids: {},
    unmutedRtcUids: {}
  },
  emits: ["show-all", "show-more"],
  setup(__props: any) {

const props = __props;



const defaultAvatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5];
const isPc = ref(false);
let mediaQueryList: MediaQueryList | undefined;

function syncIsPc(event?: MediaQueryListEvent | MediaQueryList) {
  isPc.value = Boolean(event?.matches);
}

const maxDisplayTileCount = computed(() => {
  if (!isPc.value) return props.users.length;
  if (!props.hasSharedScreen) return 9;
  return props.screenFullscreen ? 6 : 8;
});

const hiddenUserCount = computed(() => {
  if (!isPc.value) return 0;

  const maxTiles = maxDisplayTileCount.value;
  const displayLimit = maxTiles - 1;
  const total = Number.isFinite(props.totalUserCount)
    ? props.totalUserCount
    : props.users.length;

  return total > maxTiles
    ? Math.max(0, total - displayLimit)
    : 0;
});

const displayUsers = computed(() => {
  if (!isPc.value) return props.users;

  const maxTiles = maxDisplayTileCount.value;
  return hiddenUserCount.value > 0
    ? props.users.slice(0, maxTiles - 1)
    : props.users;
});

const displayTileCount = computed(() => {
  return displayUsers.value.length + (hiddenUserCount.value > 0 ? 1 : 0);
});

const userGridClass = computed(() => {
  const count = displayTileCount.value;
  const isSharedFullscreen = props.hasSharedScreen && props.screenFullscreen;
  const isSharedNormal = props.hasSharedScreen && !props.screenFullscreen;

  return {
    [`count_${count}`]: count > 0 && count <= 9,
    has_more: hiddenUserCount.value > 0,
    shared_screen: props.hasSharedScreen,
    shared_screen_grid: isSharedNormal,
    shared_screen_fullscreen_grid: isSharedFullscreen,
    screen_fullscreen: props.screenFullscreen && !props.hasSharedScreen,
  };
});

const shouldShowMobileMore = computed(() => {
  if (isPc.value) return false;
  return (
    props.users.length === props.pageSize &&
    props.totalUserCount > props.users.length
  );
});

function handleAvatarError(event: Event, user: MeetingUser, index: number) {
  const target = event.target as HTMLImageElement;
  target.src = getDefaultAvatar(user, index, defaultAvatars);
}

function userMuted(user: MeetingUser, index: number) {
  return isMuted(user, index, props.unmutedRtcUids);
}

function userSpeaking(user: MeetingUser, index: number) {
  return isRtcUidMatched(user, index, props.speakingRtcUids);
}

function shouldShowMicStatus(user: MeetingUser) {
  return getUserIdentity(user) !== 0;
}

onMounted(() => {
  mediaQueryList = window.matchMedia('(min-width: 768px)');
  syncIsPc(mediaQueryList);

  if (mediaQueryList.addEventListener) {
    mediaQueryList.addEventListener('change', syncIsPc);
  } else {
    mediaQueryList.addListener(syncIsPc);
  }
});

onUnmounted(() => {
  if (!mediaQueryList) return;

  if (mediaQueryList.removeEventListener) {
    mediaQueryList.removeEventListener('change', syncIsPc);
  } else {
    mediaQueryList.removeListener(syncIsPc);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user_grid", userGridClass.value])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayUsers.value, (user, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "user_item",
        key: _unref(getUserKey)(user, index)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["avatar_box", { active: userSpeaking(user, index) }])
        }, [
          _createElementVNode("img", {
            src: _unref(getUserAvatar)(user, index, defaultAvatars),
            onErrorOnce: ($event: any) => (handleAvatarError($event, user, index)),
            alt: ""
          }, null, 40, _hoisted_1),
          (shouldShowMicStatus(user))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["mic_status", { muted: userMuted(user, index) }])
              }, [
                _createElementVNode("img", {
                  src: userMuted(user, index) ? _unref(UserMicMutedIcon) : _unref(UserMicOnIcon),
                  alt: ""
                }, null, 8, _hoisted_2)
              ], 2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(getUserName)(user) || _ctx.$t('用户昵称')), 1),
          (_unref(getUserPledgeLogo)(user))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(getUserPledgeLogo)(user),
                alt: ""
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["role_badge", {
          speaker: _unref(getUserIdentity)(user) === 3,
          audience: _unref(getUserIdentity)(user) === 0,
        }])
        }, _toDisplayString(_ctx.$t(_unref(getRoleText)(user, index))), 3)
      ]))
    }), 128)),
    (hiddenUserCount.value > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "user_item more_user_item",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-all')))
        }, [
          _createElementVNode("div", _hoisted_5, "+" + _toDisplayString(hiddenUserCount.value), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('另外 {number} 人', { number: hiddenUserCount.value })), 1)
        ]))
      : _createCommentVNode("", true),
    (shouldShowMobileMore.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "mobile_more_button",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-more')))
        }, _toDisplayString(_ctx.$t('查看更多')), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})